// Libs
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DndContext, PointerSensor, TouchSensor, closestCorners, useSensor, useSensors } from "@dnd-kit/core";
import { useSnackbar } from 'notistack';
import Backdrop from '@mui/material/Backdrop';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';

// Components
import Header from "../Header/Header.jsx"
import PictureBox from "./PictureBox/PictureBox.jsx";
import carFeaturesListJson from "../../assets/carFeaturesList.json";

//Services
import { GET, PUT } from "../../services/Bridge.js"

// Functions
import handleImageUpload from "./handleImageUpload.js"
import handleDragEnd from "./handleDragEnd.js"
import toggleIsSelected from "./toggleIsSelected.js";

// CSS
import style from "./style.module.css";

/* const TITLE_REGEX = /^[A-z0-9ľĽšŠčČťŤžŽýÝáÁíÍéÉúÚňŇôÔřŘů.,() ]{1,72}$/;
const MOBILENUMBER_REGEX = /^\+?[0-9]{10,15}$/;
const YEAROFMANUFACTURE_REGEX = /^\d{4}$/;
const MILAGE_REGEX = /^\d{1,7}$/;
const PRICE_REGEX = /^([0-9]|[1-9][0-9]{1,5}|1000000)$/;
const DESCRIPTION_REGEX = /^[A-z0-9ľĽšŠčČťŤžŽýÝáÁíÍéÉúÚňŇôÔřŘů.,:()\n +-]*$/; */

const imageExt = process.env.REACT_APP_IMAGE_EXT;
const apiUrl = process.env.REACT_APP_API_URL;

const Edit = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, logMeOut }) => {

  const navigate = useNavigate();

  const { id } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [saving, setSaving] = useState(false);
  const [progress, setProgress] = useState(0);
  const [confirmSaveBox, setConfirmSaveBox] = useState(false);
  const [featuresBox, setFeaturesBox] = useState(false);
  const [carFeaturesList, setCarFeaturesList] = useState(carFeaturesListJson.carFeatures);


  const [title, setTitle] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [yearOfManufacture, setYearOfManufacture] = useState("");
  const [mileage, setMileage] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [stateChips, setStateChips] = useState("");
  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [minusDph, setMinusDph] = useState(false);
  const [thumbnails, setThumbnails] = useState([]);
  const [isArchived, setIsArchived] = useState();

  const [titleValid, setTitleValid] = useState(true);
  const [mobileNumberValid, setMobileNumberValid] = useState(true);
  const [yearOfManufactureValid, setYearOfManufactureValid] = useState(true);
  const [mileageValid, setMileageValid] = useState(true);
  const [priceValid, setPriceValid] = useState(true);
  const [descriptionValid, setDescriptionValid] = useState(true);

  const handleRemoveImages = () => {
    setThumbnails([]);
    setImages([]);
  };

  useEffect(() => {

    const asyncFunction = async () => {

      const getFileFromUrl = async (url, fileName) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], fileName, { type: blob.type });
        return file;
      };

      try {
        const response = await GET("advertisement", { id: id });

        setTitle(response.title);
        setMobileNumber(response.mobileNumber);
        setYearOfManufacture(response.yearOfManufacture);
        setMileage(response.mileage);
        setPrice(response.price);
        setDescription(response.description);
        setStateChips(response.stateChips);
        setFeatures(response.features)
        setMinusDph(response.minusDph);
        setIsArchived(response.isArchived);

        const imageFatching = response.images.map(async image => {
          return await getFileFromUrl(`${apiUrl}/data/${id}/templates/${image.fileName}.avif`, image.fileName);
        });

        const files = await Promise.all(imageFatching);

        const thumbnailsObjs = files.map((file, index) => {
          return {
            fileURL: URL.createObjectURL(file),
            name: `${file.name}.${response.images[index].ext}`,
            id: index
          };
        });

        setThumbnails(thumbnailsObjs);

        setCarFeaturesList(prevCarFeaturesList => {
          return prevCarFeaturesList.map(feature => {
            const isInResponse = response.features.some(oldFeature => oldFeature.short === feature.short);
            return isInResponse ? { ...feature, isSelected: true } : feature;
          });
        });

      } catch (error) {
        enqueueSnackbar(error, {
          variant: "error",
          autoHideDuration: 5000,
        });
      };
    };

    asyncFunction();

  // eslint-disable-next-line
  }, []);

  const handleSave = async () => {

    //const currentYear = new Date().getFullYear();

    /* const v1 = TITLE_REGEX.test(formData.title);
    const v2 = MOBILENUMBER_REGEX.test(formData.mobileNumber);
    let v3 = YEAROFMANUFACTURE_REGEX.test(formData.yearOfManufacture);
    v3 = formData.yearOfManufacture <= currentYear && formData.yearOfManufacture >= 1900;
    const v4 = MILAGE_REGEX.test(formData.mileage);
    const v5 = PRICE_REGEX.test(formData.price);
    const v6 = DESCRIPTION_REGEX.test(formData.description); */

    const v1 = true;
    const v2 = true;;
    const v3 = true;
    const v4 = true;
    const v5 = true;
    const v6 = true;

    setTitleValid(v1);
    setMobileNumberValid(v2);
    setYearOfManufactureValid(v3);
    setMileageValid(v4);
    setPriceValid(v5);
    setDescriptionValid(v6);

    if (!v1 || !v2 || !v3 || !v4 || !v5 || !v6) {
      enqueueSnackbar(webText.loginVerifyUserInputs, {variant: "error", autoHideDuration: 5000});
      setConfirmSaveBox(false);
      return;
    };

    setSaving(true);

    const formData = new FormData();

    for (let i = 0; i < images.length; i++) {
      formData.append('images', images[i]);
    };

    const imagesArray = thumbnails.map((thumbnail) => thumbnail.name);

    const params = {
      title: title,
      mobileNumber: mobileNumber,
      yearOfManufacture: yearOfManufacture,
      mileage: mileage,
      price: price,
      stateChips: stateChips,
      minusDph: minusDph,
      isArchived: isArchived,
      id: id,
      imagesArray
    };

    formData.append("description", description);
    formData.append("features", JSON.stringify(features));
    formData.append("params", JSON.stringify(params));

    try {
      await PUT("advertisement", formData, { id: id }, progres => setProgress(progres));

      enqueueSnackbar(webText.saved, {
        variant: "success",
        autoHideDuration: 3000,
        onEntered: () => navigate("/")
      });

    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
        autoHideDuration: 5000,
      });
    };

    navigate("/");
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor)
  );

  return (
    <>
      <Header
        webText={webText}
        toggleTheme={toggleTheme}
        toggleWebLanguage={toggleWebLanguage}
        webLanguage={webLanguage}
        webTheme={webTheme}
        logMeOut={logMeOut}
      />
      <div className={style.page}>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={confirmSaveBox}
        >
          {!saving ?
            <div className={style.confirmSaveBox}>
              <h2 className={style.title}>Prajete si uložiť inzerát ?</h2>
              <button
                className={style.confirmBtn}
                onClick={handleSave}
              >Ulož a nahraj</button>
              <button
                className={style.deniedBtn}
                onClick={() => setConfirmSaveBox(false)}
              >Zrušiť</button>
            </div>
            :
            <div className={style.confirmSaveBox2}>
              <p className={style.title}>Inzerát sa nahráva</p>
              <progress
                value={progress}
                max="100"
                className={style.progressBar}
              ></progress>
            </div>
          }
        </Backdrop>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={featuresBox}
        >
          <div className={style.featuresBox}>
            <div className={style.header}>
              <h1 className={style.title}>Vyber funkcie vozidla</h1>
              <button
                className={style.closeBtn}
                onClick={() => setFeaturesBox(false)}
              >X</button>
            </div>
            <div className={style.featuresList}>
              {
                carFeaturesList.map((carFeature, index) => (
                  <Tooltip
                    title={webLanguage === "sk" ? carFeature.description : carFeature.skTranslation}
                    key={index}
                    placement="top"
                    disableInteractive
                    arrow
                  >
                    <p
                      onClick={() => toggleIsSelected(index, { setCarFeaturesList, setFeatures })}
                      className={carFeature.isSelected ? style.active : style.nonActive}
                    >{`${carFeature.short} (${webLanguage === "sk" ? carFeature.skTranslation : carFeature.description})`}</p>
                  </Tooltip>
                ))
              }
            </div>
          </div>
        </Backdrop>
        <main className={style.main}>

          <h1 className={style.title}>Uprav inzerát</h1>

          <button
            onClick={() => setConfirmSaveBox(true)}
            className={style.saveBtn}
          >Uložiť a nahrať</button>

          <input
            type="text"
            name="title"
            value={title}
            onChange={event => setTitle(event.target.value)}
            placeholder={webText.titlePlaceholder}
            className={`${style.titleInput} ${titleValid ? null : style.error}`}
          />

          <div className={style.addImgBox}>
            <label className={style.inputBtn}>
              Vybrať fotky
              <input
                className={style.imgInput}
                type="file"
                name="images"
                multiple
                accept="image/*"
                onChange={event => handleImageUpload(event, { setThumbnails, thumbnails, setImages })}
              />
            </label>
            <button className={style.removeAllImgsBtn} onClick={handleRemoveImages}>Vymazať fotky</button>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCorners}
              onDragEnd={event => {
                handleDragEnd(event, { setThumbnails, thumbnails })
              }}
            >
              <PictureBox
                thumbnails={thumbnails}
                setThumbnails={setThumbnails}
                setImages={setImages}
              />
            </DndContext>
          </div>

          <div className={style.line}></div>

          <input
            type="text"
            name="phoneNumber"
            placeholder={webText.phoneNumberPlaceholder}
            value={mobileNumber}
            onChange={event => setMobileNumber(event.target.value)}
            className={`${style.phoneInput} ${titleValid ? null : style.error}`}
          />

          <input
            type="text"
            name="yearOfManufacture"
            placeholder={webText.yearOfManufacturePlaceholder}
            value={yearOfManufacture}
            onChange={event => setYearOfManufacture(event.target.value)}
            className={`${style.manufactureYoInput} ${titleValid ? null : style.error}`}
          />

          <div className={style.milageBox}>
            <input
              type="text"
              name="mileage"
              placeholder={webText.mileagePlaceholder}
              value={mileage}
              onChange={event => setMileage(event.target.value)}
              className={`${style.milageInput} ${titleValid ? null : style.error}`}
            />
            <p className={style.text}>Km</p>
          </div>

          <div className={style.priceBox}>
            <input
              type="text"
              name="price"
              placeholder={webText.pricePlaceholder}
              value={price}
              onChange={event => setPrice(event.target.value)}
              className={`${style.priceInput} ${titleValid ? null : style.error}`}
            />
            <p className={style.text}>€</p>
          </div>

          <div className={style.dphRemovable}>
            <button className={style.dphRemovableBtn} onClick={() => setMinusDph(prevState => !prevState)}>
              {minusDph ?
                <svg viewBox="0 0 448 512">
                  <path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
                </svg>
                :
                <svg viewBox="0 0 448 512">
                  <path d="M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"/>
                </svg>
              }
            </button>
            <p className={style.removableDphText}>Možnosť odobrať DPH</p>
          </div>

          <button
            onClick={() => setFeaturesBox(true)}
            className={style.featureBtn}
          >Dodatočné funkcie vozidla</button>

          <div className={style.btnsGroup}>
            <ToggleButtonGroup
              color="lemoneGreen"
              value={stateChips}
              onChange={(event, newFormats) => {
                setStateChips(newFormats);
              }}
              aria-label="text formatting"
            >
              <ToggleButton value="prepairing" aria-label="bold">
                {webText.prepairingButton}
              </ToggleButton>
              <ToggleButton value="reserved" aria-label="italic">
                {webText.reservedButton}
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          <textarea
            name="description"
            placeholder={webText.addItemDescription}
            value={description}
            onChange={event => setDescription(event.target.value)}
            className={`${style.descriptionInput} ${titleValid ? null : style.error}`}
          />
        </main>
      </div>
    </>
  );
};

export default Edit;